export default "__VITE_ASSET__39edcbdd__"